"use client"

import { useEffect } from "react"
import { usePathname, useSearchParams } from "next/navigation"
import { createClient } from "@/utils/supabase/client"
import { useAnalytics } from "@/hooks/useAnalytics"

// Track visitor presence and analytical events
export function StorefrontTracker({ siteId }: { siteId: string }) {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const { trackPageView, visitorId } = useAnalytics(siteId)

    // 1. Track Historical Analytics (Page Views)
    useEffect(() => {
        const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '')
        trackPageView(url)
    }, [pathname, searchParams, trackPageView])

    // 2. Realtime Presence (Live Visitors)
    useEffect(() => {
        if (!visitorId) return

        const supabase = createClient()
        const channel = supabase.channel(`site:${siteId}:visitors`)

        // console.log(`[Tracker] Joining presence channel for site ${siteId}`)

        channel
            .subscribe(async (status) => {
                if (status === 'SUBSCRIBED') {
                    await channel.track({
                        visitor_id: visitorId,
                        online_at: new Date().toISOString(),
                        page: pathname
                    })
                }
            })

        return () => {
            supabase.removeChannel(channel)
        }
    }, [siteId, visitorId, pathname])

    return null
}
